import { Experience, ExperienceItem } from '../types';
import { escapeHtml } from '../utils/security';
import { sectionHeader } from './common';

function renderExperienceItem(item: ExperienceItem): string {
    return `
        <div class="grid grid-cols-[26px_1fr] md:grid-cols-[170px_26px_1fr]">
            <!-- period/location column (desktop) -->
            <div class="hidden md:block text-right pr-2 pt-0.5">
                <div class="font-mono text-[13px] font-semibold text-graphite">${escapeHtml(item.period)}</div>
                ${item.location ? `<div class="text-[13px] text-n400 mt-1.5">${escapeHtml(item.location)}</div>` : ''}
            </div>
            <!-- timeline rail -->
            <div class="relative" aria-hidden="true">
                <div class="absolute left-1/2 top-2 -bottom-2 w-0.5 bg-n200 -translate-x-1/2"></div>
                <div class="absolute left-1/2 top-1.5 w-3.5 h-3.5 rounded-full bg-sunset border-[3px] border-sand -translate-x-1/2 shadow-[0_0_0_1px_#D3CFC5]"></div>
            </div>
            <!-- card -->
            <div class="pb-10 pl-2">
                <div class="bg-white border border-n100 rounded-lg px-[26px] py-6 shadow-sm">
                    <div class="md:hidden font-mono text-[13px] font-semibold text-graphite mb-2">${escapeHtml(item.period)}${item.location ? ` · <span class="font-normal text-n400">${escapeHtml(item.location)}</span>` : ''}</div>
                    <h3 class="text-xl leading-7 font-semibold text-graphite mb-1">${escapeHtml(item.roleTitle)}</h3>
                    <div class="text-[15px] font-semibold text-sunset-dark mb-4">${escapeHtml(item.company)}</div>
                    <ul class="flex flex-col gap-2.5 mb-[18px]">
                        ${item.bullets.map(bullet => `
                            <li class="flex items-start gap-2.5 text-[15px] leading-relaxed text-n500">
                                <i data-lucide="check" stroke-width="2" class="w-[17px] h-[17px] text-success-text flex-shrink-0 mt-[3px]"></i>
                                <span>${escapeHtml(bullet)}</span>
                            </li>
                        `).join('')}
                    </ul>
                    <div class="flex flex-wrap gap-[7px] pt-4 border-t border-n100">
                        ${item.tech.map(t => `
                            <span class="px-2.5 py-1 rounded-full font-mono text-[11px] font-medium tracking-[0.3px] bg-creme text-n500 border border-n100 inline-block">${escapeHtml(t)}</span>
                        `).join('')}
                    </div>
                </div>
            </div>
        </div>
    `;
}

export function buildExperience(experience: Experience) {
    const root = document.querySelector('[data-section="experience"]');
    if (!root) return;

    root.innerHTML = `
        ${sectionHeader(experience.kicker, experience.heading)}
        <div class="animate-fadeUp">
            ${experience.items.map(item => renderExperienceItem(item)).join('')}
        </div>
    `;
}
